import { Helmet } from "react-helmet-async";

const HelmetItem = () => {
  return (
    <Helmet>
      <title>{"AI不動産査定"}</title>
      <link
        rel="icon"
        href="https://storage.googleapis.com/bkt-ph-prod-homepage-static-public/img/favicon.d8b7874261c3.ico"
      />
      <meta name="description" content={"入力1分で売却相場がすぐわかる"} />
      <meta http-equiv="Content-Language" content="ja" />
      <meta name="google" content="notranslate" />
      {/* <link rel="canonical" href={`https:hoge.com/${""}`} /> */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </Helmet>
  );
};

export default HelmetItem;
